module.exports = __webpack_public_path__ + "Worldline-Coconut-Horizontal.a3021b649291b36b9c6df5e59c5cf25e.png";